// IMPORTANT: These are bare module paths (without plane prefix).
// They are used ONLY for route registration in the module registry —
// the router adds /platform at registration time via createRouteUnderLayout.
// For navigation, use ROUTE_PATHS.* from @modules/core/config/modules,
// which carries the correct plane prefix. Do NOT import ROUTE_PATHS here
// as it would create a circular dependency.

// Bare path used for navigation back to the communications page.
// Navigation callers must use ROUTE_PATHS.communications instead of this
// constant to get the /platform-prefixed path.
export const COMMUNICATIONS_ROUTE_PATH: string = '/users/communications';

// These paths are used only for route registration, not navigation.
export const MESSAGE_TEMPLATES_ROUTE_PATHS = {
  messageTemplates: '/users/communications/message-templates',
  editMessageTemplate: '/users/communications/message-templates/$templateName/edit',
  inspectMessageTemplate: '/users/communications/message-templates/$templateName/inspect',
};

export const MESSAGE_TEMPLATES_API_PATHS = {
  templates: '/v1/api/platform/users/message-template',
  nameList: '/v1/api/platform/users/message-template/name-list',
  create: '/v1/api/platform/users/message-template/create',
  editByName: '/v1/api/platform/users/message-template/:templateName/edit',
  configure: '/v1/api/platform/users/message-template/:messageTemplateId/configure',
  countries: '/v1/api/platform/users/message-template/:templateName/countries',
  users: '/v1/api/platform/users/message-template/:templateName/users',
  inspect: '/v1/api/platform/users/message-template/inspect',
};

export const MessageTemplatesQueryKeys = {
  all: () => ['message-templates'] as const,
  list: (messageType: string, page: number, size: number, templateName?: string) =>
    [...MessageTemplatesQueryKeys.all(), 'list', messageType, page, size, templateName] as const,
  detail: (id: number) => [...MessageTemplatesQueryKeys.all(), 'detail', id] as const,
};
